import protoRoot from "../proto-root";
import ActivityLogEvent from "./ActivityLogEvent";

function create({ data, event }) {
  const ActivityLogVideoSnapshotPreview = protoRoot.lookupType(
    "comm.ActivityLogVideoSnapshotPreview"
  );

  return ActivityLogVideoSnapshotPreview.create({
    event: ActivityLogEvent.create(event),
    data
  });
}

export default {
  create
};

// message ActivityLogVideoSnapshotPreview {
//     ActivityLogEvent event = 1;
//     bytes data = 2;
//   }
